import React, { useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { toggleMenu } from "../../utils/helpers";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { formatToDateOnly } from "../../utils/helpers";
import {
  API_PROJECT,
  API_LEAVE_GET_OOD_DL_LIST,
  API_GET_PRINCIPAL_SPONSOR_LIST,
  API_GET_PROJECT_MANAGER_LIST,
  API_GET_LEAD_BUSINESS_ANALYST_LIST,
  EMPLOYEE_LIST,
} from "../../config/Endpoints";
import { useNavigate } from "react-router-dom";
import "../../Styles/style.css";
import { getApi } from "../../utils/api";
import { useEffect } from "react";
import axios from "axios";
import CharLimitTextArea from "../../components/Performance/CharLimitTextArea";
import { projectTypeOptions } from "../../options/projectTypesOptions";

const CreateProject = ({ title, description }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [deliveryLead, setDeliveryLead] = useState([]);
  const [principalSponsors, setPrincipalSponsors] = useState([]);
  const [projectManagers, setProjectManagers] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const accessToken = Cookies.get("accessToken");
  const [leadBusinessAnalysts, setLeadBusinessAnalysts] = useState([]);
  const [formData, setFormData] = useState({
    projectName: "",
    projectType: "",
    dlId: "",
    dlName: "",
    startDate: "",
    endDate: "",
    sowStartDate: "",
    sowEndDate: "",
    commercialSummary: "",
    projectManager: "",
    principalSponsor: "",
    leadBusinessAnalyst: "",
  });

  const dateBadgeStyle = {
    backgroundColor: "#F5F7FA",
    fontWeight: 500,
    color: "rgba(92, 99, 192, 0.9)",
    fontSize: "12px",
    padding: "0 4px ",
    marginLeft: "8px",
    position: "absolute",
    top: "-9px",
    zIndex: 1,
  };

  useEffect(() => {
    const fetchLBA = async () => {
      try {
        const response = await getApi(
          API_GET_LEAD_BUSINESS_ANALYST_LIST,
          accessToken
        );
        const lbas = (response.data?.data || []).map((lba) => ({
          value: lba.id,
          label: `${lba.firstName} ${lba.lastName}`,
        }));
        setLeadBusinessAnalysts(lbas);
      } catch (error) {
        console.error("Error fetching LBAs:", error);
        setLeadBusinessAnalysts([]);
      }
    };
    fetchLBA();
  }, []);

  useEffect(() => {
    const fetchProjectManagers = async () => {
      try {
        const response = await getApi(
          API_GET_PROJECT_MANAGER_LIST,
          accessToken
        );

        const managers = (response.data?.data || []).map((pm) => ({
          value: pm.id,
          label: `${pm.firstName} ${pm.lastName}` || "",
        }));

        setProjectManagers([...managers]);
      } catch (error) {
        console.error("Error fetching project managers:", error);
        setProjectManagers([]);
      } finally {
      }
    };

    fetchProjectManagers();
  }, []);

  useEffect(() => {
    const fetchPrincipalSponsors = async () => {
      try {
        const response = await getApi(
          API_GET_PRINCIPAL_SPONSOR_LIST,
          accessToken
        );

        const sponsors = (response.data?.data || []).map((sponsor) => ({
          value: sponsor.id,
          label:
            `${sponsor.firstName} ${sponsor.lastName}` || "Unnamed Sponsor",
        }));

        setPrincipalSponsors([...sponsors]);
      } catch (error) {
        console.error("Error fetching principal sponsors:", error);
        setPrincipalSponsors([]);
      }
    };

    fetchPrincipalSponsors();
  }, []);

  useEffect(() => {
    const fetchDeliveryLeads = async () => {
      try {
        const response = await getApi(API_LEAVE_GET_OOD_DL_LIST, accessToken);

        const leads = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        setDeliveryLead([
          ...leads.map((lead) => ({
            value: lead.id,
            label: lead.fullName || "",
          })),
        ]);
      } catch (error) {
        console.error("Error fetching delivery leads:", error);
        setDeliveryLead([]);
      }
    };

    fetchDeliveryLeads();
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getApi(EMPLOYEE_LIST, accessToken);
        const employees = (response.data?.data || []).map((e) => ({
          value: e.id,
          label: e.empName || "Unnamed Employee",
        }));
        setEmployeeList([...employees]);
      } catch (error) {
        console.error("Error fetching employees:", error);
      } finally {
      }
    };
    fetchEmployees();
  }, []);

  const handleInputChange = (name, value) => {
    if (
      name === "sowStartDate" ||
      name === "sowEndDate" ||
      name === "startDate" ||
      name === "endDate"
    ) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      if (!formData.projectName.trim()) {
        toast.error("Project Name is required", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        return;
      }

      if (!formData.commercialSummary.trim()) {
        toast.error("Project Description is required", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        return;
      }

      if (!formData.sowStartDate) {
        toast.error("SOW Start Date is required", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        return;
      }

      const payload = {
        projectName: formData.projectName.trim(),
        projectType: formData.projectType,
        deliveryLead: parseInt(formData.dlId),
        startDate: formatToDateOnly(formData.startDate),
        endDate: formatToDateOnly(formData.endDate),
        sowStartDate: formatToDateOnly(formData.sowStartDate),
        sowEndDate: formatToDateOnly(formData.sowEndDate),
        commercialSummary: formData.commercialSummary.trim(),
        projectManager: formData.projectManager,
        principalSponsor: formData.principalSponsor,
        leadBusinessAnalyst: formData.leadBusinessAnalyst,
      };

      const response = await axios.post(API_PROJECT, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      toast.success(response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      navigate("/dashboard/projectList");

      setFormData({
        projectName: "",
        projectType: "",
        dlId: "",
        dlName: "",
        startDate: "",
        endDate: "",
        sowStartDate: "",
        sowEndDate: "",
        commercialSummary: "",
        projectManager: "",
        principalSponsor: "",
        leadBusinessAnalyst: "",
      });
    } catch (error) {
      if (error.response) {
        const errorMessage =
          error.response.data?.message ||
          error.response.data?.error ||
          `Server error: ${error.response.status}`;
        toast.error(`Failed to submit project: ${errorMessage}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else if (error.request) {
        console.error("No response received:", error.request);
        toast.error("Failed to submit project: No response from server", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(`Failed to submit project: ${error.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="page-heading mb-0">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <form id="assign-asset" onSubmit={handleSubmit}>
        <div className="px-4">
          <div className="inputs">
            <div className="row justify-content-between">
              <div className="col-md-6">
                <div className="row p-3">
                  <div className="col-md-12 justify-content-between row p-0 mt-4">
                    <div className="col-md-4  p-0 ">
                      <label htmlFor="projectName" className="has-asterisk">
                        Project Name
                      </label>
                    </div>
                    <div className="col-md-7 p-0  ">
                      <div className="input-group">
                        <input
                          type="text"
                          name="projectName"
                          value={formData.projectName}
                          onChange={(e) => {
                            let value = e.target.value;
                            if (value.startsWith(" ")) {
                              return;
                            }
                            value = value.replace(/\s{3,}/g, "  ");
                            if (/^\d+$/.test(value)) {
                              return;
                            }
                            const hasAlphabet = /[a-zA-Z]/.test(value);

                            if (hasAlphabet) {
                              const specialCount = (
                                value.match(/[^a-zA-Z0-9 ]/g) || []
                              ).length;

                              if (specialCount > 5) {
                                return;
                              }
                            } else {
                              value = value.replace(/[^a-zA-Z0-9 ]/g, "");
                            }

                            setFormData((prev) => ({
                              ...prev,
                              projectName: value,
                            }));
                          }}
                          maxLength={50}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 justify-content-between row p-0 mt-4">
                    <div className="col-md-4 p-0  ">
                      <label
                        htmlFor="principalSponsor"
                        className="has-asterisk"
                      >
                        Project Type
                      </label>
                    </div>
                    <div className="col-md-7  p-0 ">
                      <Select
                        className="custom-select"
                        classNamePrefix="react-select"
                        name="projectType"
                        placeholder="Select Project Type"
                        options={projectTypeOptions}
                        value={
                          projectTypeOptions.find(
                            (option) => option.value === formData.projectType
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            projectType: selectedOption?.value || "",
                          }))
                        }
                        isClearable
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12 justify-content-between row p-0 mt-4">
                    <div className="col-md-4 p-0 ">
                      <label htmlFor="deliveryLead" className="has-asterisk">
                        Delivery Lead
                      </label>
                    </div>
                    <div className="col-md-7 p-0">
                      <Select
                        className="custom-select"
                        classNamePrefix="react-select"
                        name="dlId"
                        value={
                          deliveryLead.find(
                            (lead) => lead.value === formData.dlId
                          ) || null
                        }
                        onChange={(selectedOption) => {
                          setFormData((prev) => ({
                            ...prev,
                            dlId: selectedOption?.value || "",
                            dlName: selectedOption?.label || "",
                          }));
                        }}
                        options={deliveryLead}
                        placeholder="Select  Delivery Lead"
                        required
                        isClearable
                      />
                    </div>
                  </div>

                  <div className="col-md-12 justify-content-between row p-0 mt-4">
                    <div className="col-md-4 p-0">
                      <label htmlFor="projectName" className="has-asterisk">
                        Project Manager
                      </label>
                    </div>
                    <div className="col-md-7 p-0">
                      <Select
                        className="custom-select"
                        classNamePrefix="react-select"
                        name="projectManager"
                        placeholder="Select Project Manager"
                        options={projectManagers}
                        value={
                          projectManagers.find(
                            (e) => e.value === formData.projectManager
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            projectManager: selectedOption?.value || "",
                          }))
                        }
                        isClearable
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-12 justify-content-between row p-0 mt-4">
                    <div className="col-md-4 p-0  ">
                      <label
                        htmlFor="principalSponsor"
                        className="has-asterisk"
                      >
                        Principal Sponsor
                      </label>
                    </div>
                    <div className="col-md-7  p-0 ">
                      <Select
                        className="custom-select"
                        classNamePrefix="react-select"
                        name="principalSponsor"
                        placeholder="Select Principal Sponsor"
                        options={principalSponsors}
                        value={
                          principalSponsors.find(
                            (e) => e.value === formData.principalSponsor
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            principalSponsor: selectedOption?.value || "",
                          }))
                        }
                        isClearable
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12 row p-0 justify-content-between mt-4">
                    <div className="col-md-4 p-0">
                      <label htmlFor="leadBusinessAnalyst">
                        Lead Business Analyst
                      </label>
                    </div>
                    <div className="col-md-7  p-0">
                      <Select
                        className="custom-select"
                        classNamePrefix="react-select"
                        name="leadBusinessAnalyst"
                        placeholder="Select Lead Business Analyst "
                        options={leadBusinessAnalysts}
                        value={
                          leadBusinessAnalysts.find(
                            (e) => e.value === formData.leadBusinessAnalyst
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            leadBusinessAnalyst: selectedOption?.value || "",
                          }))
                        }
                        isClearable={true}
                      />
                    </div>
                  </div>

                  <div className="col-md-12 justify-content-between row p-0 mt-4">
                    <div className="col-md-4 p-0">
                      <label htmlFor="sowStartDate">SOW</label>
                    </div>
                    <div className="col-md-7 p-0">
                      <div className="row">
                        <div className="col-md-6 position-relative pe-2">
                          <span style={dateBadgeStyle}>Start Date</span>
                          <DatePicker
                            showIcon
                            toggleCalendarOnIconClick
                            placeholderText="mm/dd/yyyy"
                            selected={formData.sowStartDate}
                            onChange={(date) =>
                              handleInputChange("sowStartDate", date)
                            }
                            className="border custom-date"
                            required
                            onKeyDown={(e) => {
                              if (e.key !== "Backspace" && e.key !== "Delete") {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <div className="col-md-6 position-relative ps-2">
                          <span style={dateBadgeStyle}>End Date</span>
                          <DatePicker
                            showIcon
                            toggleCalendarOnIconClick
                            placeholderText="mm/dd/yyyy"
                            selected={formData.sowEndDate}
                            onChange={(date) =>
                              handleInputChange("sowEndDate", date)
                            }
                            className="border custom-date"
                            minDate={formData.sowStartDate}
                            onKeyDown={(e) => {
                              if (e.key !== "Backspace" && e.key !== "Delete") {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 justify-content-between row p-0 mt-4">
                    <div className="col-md-4 p-0">
                      <label htmlFor="startDate">Actual</label>
                    </div>
                    <div className="col-md-7 p-0">
                      <div className="row">
                        <div className="col-md-6 position-relative pe-2">
                          <span style={dateBadgeStyle}>Start Date</span>
                          <DatePicker
                            showIcon
                            toggleCalendarOnIconClick
                            placeholderText="mm/dd/yyyy"
                            selected={formData.startDate}
                            onChange={(date) =>
                              handleInputChange("startDate", date)
                            }
                            onKeyDown={(e) => {
                              if (e.key !== "Backspace" && e.key !== "Delete") {
                                e.preventDefault();
                              }
                            }}
                            maxDate={
                              formData.sowEndDate
                                ? new Date(formData.sowEndDate)
                                : null
                            }
                            className="border custom-date"
                          />
                        </div>
                        <div className="col-md-6 position-relative ps-2">
                          <span style={dateBadgeStyle}>End Date</span>
                          <DatePicker
                            showIcon
                            toggleCalendarOnIconClick
                            placeholderText="mm/dd/yyyy"
                            selected={formData.endDate}
                            onChange={(date) =>
                              handleInputChange("endDate", date)
                            }
                            className="border custom-date"
                            minDate={
                              formData.startDate
                                ? new Date(formData.startDate)
                                : null
                            }
                            onKeyDown={(e) => {
                              if (e.key !== "Backspace" && e.key !== "Delete") {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row p-3 ">
                  <div className="col-md-12 p-0 mt-4 ">
                    <label
                      htmlFor="principalSponsor"
                      className="has-asterisk mb-3"
                    >
                      Project Description
                    </label>

                    <div className="input-group">
                      <CharLimitTextArea
                        id="commercialSummary"
                        name="commercialSummary"
                        required
                        rows={17}
                        placeholder="Type Here"
                        maxLength={1500}
                        value={formData.commercialSummary}
                        onChange={(e) =>
                          handleInputChange(e.target.name, e.target.value)
                        }
                        lengthParam={formData.commercialSummary?.length || 0}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />

          <div className="action text-center ">
            <button
              className="btn theme-button px-4"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <ThreeDots
                  height="22"
                  width="60"
                  radius="9"
                  color="white"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              ) : (
                " Submit "
              )}
            </button>

            <Link to="/dashboard/projectList" className="brand-color">
              <button type="button" className="theme-button ms-3 px-4 bg-grey">
                Cancel
              </button>
            </Link>

            <a
              data-bs-toggle="modal"
              data-bs-target="#staticBackdropAsset"
              className="open-modal visually-hidden"
            >
              click
            </a>
          </div>
        </div>
      </form>
    </>
  );
};

export default CreateProject;
